<template>
<div class="cellinputbox">

  <van-field v-model="inputValue" readonly   name="name" type="number" :label-width='labelWidth'  placeholder="请输入成绩"
          :rules="[{ required: rules }]" >
            <template #label >
              <slot name="label" ></slot>
            </template>


    <template #input >
              <slot name="input" ></slot>
 <el-input-number v-model="inputValue" :controls='false' :precision='precision' :max="maxNumber" ></el-input-number>
            </template>


             <template #button >
                 <slot name="button" ></slot>
            </template>
  </van-field>

</div>

</template>
<script>
export default {
  name: 'CustomButton',
  components: {},
   model: {
    prop: 'value',
    event: 'input'
  },
  props: {
   length: {
      type: [String,Number],
      default: 3,
   },
   label: {
      type: String,
      default: "label",
   },
   value: {
      type: [String,Number],
      default: undefined,
   },
   maxNumber: {
      type: [Number],
      default: 99999,
   },
   
   minNumber: {
      type: [String,Number],
      default: null,
   },
   labelWidth: {
      type: [String,Number],
      default: 110,
   },
  //  精度
   precision: {
      type: [String,Number],
      default: null,
   },
rules: {
      type: [Boolean],
      default: false,
   },
   
  },
  data() {
    return {
inputValueList:[],
precisionList:[]
    }
  },
  watch:{

//  inputValue(newVal,oldVal) {

//             if(newVal<0){
//                 this.$toast('输入不能为负数！');
//                 this.inputValue = ''
//             }
//             // 解决数字键盘可以输入输入多个小数点问题
//             // 保留两位小数
//             if(newVal){
//                 newVal = newVal.toString();
//                 if (newVal.length>this.length) {
//                 this.inputValue = oldVal
//                 // this.$toast(`输入最大长度为${this.length+ this.precision}！`);
//                 // this.$toast(`输入最大值为${this.maxNumber}！`);
//                 return ;
//                 }
//                 // 添加小数点
//                 if (this.precision) {
//                  newVal.toFixed(this.precision)
//                 // newVal = (newVal / (this.precision*10)).toFixed(this.precision)
//                 }


//                 if((+newVal > +this.maxNumber)&&this.maxNumber){
//                 this.inputValue = oldVal
//                 this.$toast(`输入最大值为${this.maxNumber}！`);
//                 return ;
//                 }
//                 console.log(newVal,oldVal);
//             }
  
//            let  inputValueList = this.inputValue.toString().split('')||[]
//            inputValueList.length = this.length + this.precision
//            this.inputValueList = inputValueList
       
        
 
//         },
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(val) {
        // this.value = val
        this.$emit('input', val)
      }
    }
  },
  created() {

  },
mounted () {
  this.init()
    console.log(this.length,2);
},
  methods: {
   
    click(){
this.$emit('click')
    },
  init(){
  this.inputValueList =[]
  for (let index = 0; index < this.length + this.precision; index++) {
    this.inputValueList.push('')
  }
// console.log(this.inputValueList);


    },

   clickInput() {
    this.$emit("click");
  },
  replayClick(){
    this.inputValue = undefined
  },
  },
}
</script>

<style lang="less" scoped>
.cellinputbox{
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #646566;
  ::v-deep .el-input__inner{
    border: 0px;
    border-bottom: 1px solid #b9b8b8;
  }
//   padding: 8px;
  .ulBox{
    display: flex;
  }
  .liBox{
    margin: 0 5px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    background: #fff;
    font-size: 22px;
    font-weight: 700;
    text-align: center;
  }
}

  .text{
    font-size: 20px;
    font-weight: normal;
  }
.placeholdertext{
    font-size: 14px;
    color: #929296;
}
  /deep/.style1.van-button--disabled {
    background: #e1e1e1 !important;
    box-shadow: none !important;
    opacity: 1 !important;
  }
</style>
